<template>
	<!-- <v-stepper v-model="e1" flat non-linear>
		<v-stepper-header class="login-stepper">
			<v-stepper-step :complete="e1 > 1" step="1"> Login </v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="e1 > 2" step="2"> Rol </v-stepper-step>
		</v-stepper-header>

		<v-stepper-items>
			<v-stepper-content step="1"> -->
	<v-card class="px-5 pb-5 login-stepper">
		<v-row class="d-flex justify-center py-4">
			<h3>{{ $t('login.identify') }}</h3>
		</v-row>
		<v-row class="d-flex justify-center pt-4">
			<v-col :cols="12" :md="6" :lg="4">
				<v-form>
					<v-text-field
						prepend-icon="mdi-account "
						name="Email"
						:label="$t('login.email')"
						type="text"
						v-model="login.usr"
  						autocomplete="null"
					></v-text-field>
					<v-text-field
						id="password"
						prepend-icon="mdi-lock "
						name="password"
						:label="$t('login.password')"
						type="password"
						v-model="login.password"
  						autocomplete="null"
					></v-text-field>
					<forgot-password />
				</v-form>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" class="d-flex justify-center">
				<v-btn color="info" @click="handleLogin">{{ $t('login.access') }}</v-btn>
			</v-col>
			<v-col cols="12" class="d-flex justify-center">
				<p>{{ $t('login.textcreateaccount') }}</p>
				<registry />
			</v-col>
		</v-row>
	</v-card>
	<!-- </v-stepper-content>

			<v-stepper-content step="2">
				<v-card class="px-5 py-5" style="min-width: 30rem">
					<v-autocomplete v-model="selectedRol" :label="`selecciona el rol!`" :items="roles"></v-autocomplete>
					<v-btn color="primary" @click="setWorkingRole"> Confirmar </v-btn>
				</v-card>
			</v-stepper-content>
		</v-stepper-items>
	</v-stepper> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ForgotPassword from './ForgotPassword.vue';
import Registry from './Registry.vue';

export default {
	components: { 'forgot-password': ForgotPassword, Registry },
	name: 'Login',
	props: {
		source: String
	},
	data: () => ({
		login: {
			usr: '',
			password: ''
		},
		e1: 1,
		selectedRol: ''
	}),
	computed: {
		...mapGetters(['getSession', 'getLogin', 'getIsAnonymus', 'getSelectedRol']),
		roles() {
			return this.getLogin.profiles || [];
		}
	},
	mounted() {
		const notExistSelectedRol = this.getSelectedRol === undefined || this.getSelectedRol === null || this.getSelectedRol === '';

		!this.getIsAnonymus && notExistSelectedRol && (this.e1 = 2);
	},
	methods: {
		...mapActions(['LOGIN', 'SET_WORKING_ROLE', 'LOGOUT']),
		handleLogin() {
			const startLogin = this.getIsAnonymus ? () => this.LOGOUT() : () => Promise.resolve();

			startLogin()
				.then(() => this.LOGIN(this.login))
				.then(() => this.SET_WORKING_ROLE('VISITOR'))
				.then(() => {
					this.$emit('loginSuccessful');

					// if (this.getSession) {
					// 	this.e1 = 2;
					// }
				});
		},
		setWorkingRole() {
			this.SET_WORKING_ROLE(this.selectedRol)
				.then(() => {
					this.$emit('loginSuccessful');
				})
				.finally(() => {
					this.e1 = 1;
				});
		}
	}
};
</script>

<style>
.login-stepper {
	box-shadow: none !important;
}

.login-stepper-container {
	box-shadow: none !important;
}
</style>
